import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@meddata/core/services';
import { inject } from '@angular/core';
import { Role } from '@meddata/constants';

/**
 * RoleGuard is a route guard function used to determine whether a user has the required role
 * to access a particular route. It evaluates the role specified in the route's metadata and verifies
 * it against the roles assigned to the authenticated user.
 *
 * If no specific role is defined in the route's metadata, it defaults to checking if the user has the
 * "DOCTOR" role.
 *
 * @example
 * {
 *          path: 'only-admin',
 *          component: 'OnlyAdminComponent',
 *          canActivate: [RoleGuard],
 *          data: {role: Role.ADMIN}
 *  }
 * @param {Route} route - The route object containing metadata, including the required role.
 * @returns {boolean} Returns true if the user has the required role; otherwise, false.
 */
export const RoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
	const authService: AuthService = inject(AuthService);
	const requiredRole: Role = route.data?.['role'] ?? Role.DOCTOR;

	if (authService.hasRole(requiredRole)) return true;
	return inject(Router).createUrlTree(['/statistiche']);
};
